import React, { useEffect } from 'react';

const overlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'rgba(10, 14, 39, 0.95)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1000,
  padding: 16,
  boxSizing: 'border-box',
};

const panelBase = {
  width: '100%',
  maxWidth: 420,
  padding: 40,
  background: 'rgba(10, 14, 39, 0.95)',
  borderRadius: 16,
  border: '1px solid rgba(0, 212, 255, 0.35)',
  boxShadow: '0 8px 32px rgba(0,0,0,0.4), 0 0 40px rgba(0, 212, 255, 0.15)',
};

const titleStyle = {
  fontSize: '1.5rem',
  fontWeight: 700,
  background: 'linear-gradient(135deg, #B026FF 0%, #00D4FF 100%)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
  marginBottom: 8,
};

/**
 * Overlay centralizado com painel (tema escuro / borda cyan). Use `closeOnBackdrop={false}` para fluxos bloqueados (ex.: primeiro acesso).
 */
export default function Modal({
  open = true,
  onClose,
  title,
  children,
  footer,
  closeOnBackdrop = true,
  style,
  className,
}) {
  const canDismiss = Boolean(closeOnBackdrop && onClose);

  useEffect(() => {
    if (!open || !canDismiss) return;
    const onKeyDown = (e) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        onClose();
      }
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [open, canDismiss, onClose]);

  if (!open) return null;

  const handleBackdropClick = (e) => {
    if (e.target !== e.currentTarget) return;
    if (canDismiss) onClose();
  };

  const renderTitle = () => {
    if (title == null || title === '') return null;
    if (typeof title === 'string') {
      return <h2 style={titleStyle}>{title}</h2>;
    }
    return title;
  };

  return (
    <div
      role="dialog"
      aria-modal="true"
      style={overlayStyle}
      onClick={handleBackdropClick}
    >
      <div
        className={className}
        style={{ ...panelBase, ...style }}
        onClick={(e) => e.stopPropagation()}
      >
        {renderTitle()}
        {children}
        {footer}
      </div>
    </div>
  );
}
